import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { TrimCards } from "@project-management-system/shared-models";
import { Repository } from "typeorm";
import { StylesEntity } from "../dto/style-carhartt.entity";
@Injectable()
export class StyleRepo extends Repository<StylesEntity> {
    constructor(@InjectRepository(StylesEntity) private styleRepo: Repository<StylesEntity>
    ) {
        super(styleRepo.target, styleRepo.manager, styleRepo.queryRunner);
    }

    async getAllCarharttMeasurementData(): Promise<TrimCards[]> {
        let query = (`      
                    SELECT s.id,s.style AS styleData,s.season AS seasonData,s.style_description AS styleDescription,s.submit_date AS submitDate,s.tech_pack AS techPack,
                    s.state_data AS stateData,s.factory AS factory,s.approval_type AS approvalType,s.factory_merchandiser_sign AS factoryMerchandiserSign,
                    s.comments,s.approved_by AS approvedBy,s.created_at AS createdAt,s.drop_down AS dropDown ,s.pdf_file_path AS filePath,s.pdf_file_name AS fileName,s.pdf_original_name AS originalName,s.image_files as imageFiles,s.image_original_name AS imageOriginalName,s.status
                    FROM styles_entity s
                    WHERE s.status ='OPEN'
                    `)
        const result = await this.query(query);
        return result.map((rec) => {
            const combinedProductPlusColor = {
                combinedFabricColorHeaders: [],
                combinedLabelColorHeaders: [],
                combinedPackingColorHeaders: [],
                combinedTrimColorHeaders: []
            },
                combinedColumbiaPlusColor = {
                    combinedColumbiaFabricHeaders: [],
                    combinedColumbiaSewingHeaders: [],
                    combinedColumbiaPackingHeaders: [],
                    combinedColumbiaEmbellishmentHeaders: []
                },
                combinedCKPlusColor = {
                    combinedCKFabricAndLiningColorHeaders: [],
                    combinedCKZippersColorHeaders: [],
                    combinedCKTrimsColorHeaders: [],
                }
            return new TrimCards(rec.id, rec.styleData, rec.seasonData, rec.styleDescription, rec.submitDate, rec.techPack, rec.stateData, rec.factory, rec.approvalType, rec.factoryMerchandiserSign, rec.comments, rec.approvedBy, rec.createdAt, rec.dropDown, rec.filePath, rec.fileName, rec.originalName, rec.imageFiles, rec.imageOriginalName, rec.status, combinedProductPlusColor, combinedColumbiaPlusColor, combinedCKPlusColor)

        }


        )
    };

    async getAllCarharttMeasurementDataPDMFolders(): Promise<TrimCards[]> {
        let query = (`      
                    SELECT s.id,s.style AS styleData,s.season AS seasonData,s.style_description AS styleDescription,s.submit_date AS submitDate,s.tech_pack AS techPack,
                    s.state_data AS stateData,s.factory AS factory,s.approval_type AS approvalType,s.factory_merchandiser_sign AS factoryMerchandiserSign,
                    s.comments,s.approved_by AS approvedBy,s.created_at AS createdAt,s.drop_down AS dropDown ,s.pdf_file_path AS filePath,s.pdf_file_name AS fileName,s.pdf_original_name AS originalName,s.image_files as imageFiles,s.image_original_name AS imageOriginalName,s.status
                    FROM styles_entity s
                    `)
        const result = await this.query(query);
        return result.map((rec) => {
            const combinedProductPlusColor = {
                combinedFabricColorHeaders: [],
                combinedLabelColorHeaders: [],
                combinedPackingColorHeaders: [],
                combinedTrimColorHeaders: []
            },
            combinedColumbiaPlusColor = {
                combinedColumbiaFabricHeaders: [],
                combinedColumbiaSewingHeaders: [],
                combinedColumbiaPackingHeaders: [],
                combinedColumbiaEmbellishmentHeaders: []
            },
                combinedCKPlusColor = {
                    combinedCKFabricAndLiningColorHeaders: [],
                    combinedCKZippersColorHeaders: [],
                    combinedCKTrimsColorHeaders: [],
                }
            return new TrimCards(rec.id, rec.styleData, rec.seasonData, rec.styleDescription, rec.submitDate, rec.techPack, rec.stateData, rec.factory, rec.approvalType, rec.factoryMerchandiserSign, rec.comments, rec.approvedBy, rec.createdAt, rec.dropDown, rec.filePath, rec.fileName, rec.originalName, rec.imageFiles, rec.imageOriginalName, rec.status, combinedProductPlusColor, combinedColumbiaPlusColor, combinedCKPlusColor)

        }


        )
    };
}

